import SvgIcon from "@mui/material/SvgIcon";

interface OpenDrawerIconProps {
  children?: React.ReactNode;
  color?: string;
  fontSize?: number | string;
}

const OpenDrawerIcon: React.FC<OpenDrawerIconProps> = (props) => {
  return (
    <SvgIcon
      sx={{
        fontSize: props.fontSize,
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="openDrawer"
        data-name="openDrawer"
        viewBox="0 0 512 512"
        fill={props.color}
      >
        <g>
          <path d="m75 90h80c8.284 0 15-6.716 15-15s-6.716-15-15-15h-80c-8.284 0-15 6.716-15 15s6.716 15 15 15z" />
          <path d="m75 150h80c8.284 0 15-6.716 15-15s-6.716-15-15-15h-80c-8.284 0-15 6.716-15 15s6.716 15 15 15z" />
          <path d="m75 210h80c8.284 0 15-6.716 15-15s-6.716-15-15-15h-80c-8.284 0-15 6.716-15 15s6.716 15 15 15z" />
          <path d="m457 0h-402c-30.327 0-55 24.673-55 55v402c0 30.327 24.673 55 55 55h402c30.327 0 55-24.673 55-55v-402c0-30.327-24.673-55-55-55zm-257 482h-145c-13.785 0-25-11.215-25-25v-402c0-13.785 11.215-25 25-25h145zm282-25c0 13.785-11.215 25-25 25h-227v-211h168.787l-24.393 24.393c-5.858 5.858-5.858 15.355 0 21.213s15.355 5.858 21.213 0l50-50c5.858-5.858 5.858-15.355 0-21.213l-50-50c-5.858-5.858-15.355-5.858-21.213 0s-5.858 15.355 0 21.213l24.393 24.394h-168.787v-211h227c13.785 0 25 11.215 25 25z" />
        </g>
      </svg>
    </SvgIcon>
  );
};

export default OpenDrawerIcon;
